import React from 'react';
import debounce from 'lodash-decorators/debounce';

import PropTypes from 'prop-types';

import WixSDK from 'shared/utils/wix-sdk';
import { REFRESH_EVENT, storeForReload } from 'widget/utils/reload';
import { getCompId } from 'shared/utils/comp-id';

const RELOAD_STORAGE_READY = 'reloadStorageReady';

// TODO: enhance this to look like real storage with get/set/remove methods

/*
 * Since after UOU login or logout, whole site rebuilds, and there is no nice solution in WixSDK for this case.
 * This is workaround, that use persistent events in Wix.PubSub. Anytime we let user login or logout, we also
 * stores data, that we want to path into "next state" of widget after it's reloaded. But since we use
 * persistent events, they are stored in same sequence as we publish them until site is closed or manually refreshed.
 * But we need only last one, that's why we use @debounce for method `processRetrievedData`
 */
export class PersistentEvents extends React.Component {
  static propTypes = {
    onEvent: PropTypes.func,
  };

  static defaultProps = {
    onEvent: _.noop,
  };

  componentDidMount() {
    storeForReload(RELOAD_STORAGE_READY);
    WixSDK.PubSub.subscribe(REFRESH_EVENT, this.saveEventData, true);
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  lastEventData = {};

  unsubscribe() {
    WixSDK.PubSub.unsubscribe(REFRESH_EVENT, this.saveEventData);
    storeForReload(null);
  }

  saveEventData = ({ data }) => {
    if (!data || data.stored !== RELOAD_STORAGE_READY) {
      this.lastEventData = data || {};
    }
    this.retrieveDataAfterReload();
  };

  isTheSameRootComponent() {
    return this.lastEventData.rootCompId === getCompId();
  }

  @debounce(300)
  retrieveDataAfterReload() {
    const { stored } = this.lastEventData;

    if (this.isTheSameRootComponent() && stored) {
      this.props.onEvent(stored);
    }

    this.lastEventData = {};
  }

  render() {
    return null;
  }
}
